function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { defineComponent, reactive, ref, watch } from "vue";
import { definePropType } from "@types-vue/props";
import { PushNameCode } from "./config";
import PushName from "./push-name.vue";
export default defineComponent({
    components: {
        PushName: PushName
    },
    props: {
        // 是否批量推送
        batch: Boolean,
        materialNameOptions: {
            type: definePropType(Array),
            required: true
        },
        // 后缀配置
        materialNameSuffixOptions: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        nameValidator: {
            type: definePropType(Function)
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var validateName = function validateName(rule, value, callback) {
            var strArr = value.split("_");
            var all = _toConsumableArray(props.materialNameOptions).concat(_toConsumableArray(props.materialNameSuffixOptions));
            var name = strArr.map(function(str) {
                all.forEach(function(item) {
                    str = str.replaceAll("{".concat(item.label, "}"), "");
                });
                return str;
            }).filter(Boolean).join("_");
            if (!props.nameValidator) {
                callback();
                return;
            }
            props.nameValidator(name).then(function() {
                callback();
            }).catch(function(err) {
                callback(new Error(err));
            });
        };
        var copyName = // 复制名称
        function copyName(val) {
            formValue.name = val;
            emit("input", val);
        };
        var updateName = function updateName() {
            var all = _toConsumableArray(props.materialNameOptions).concat(_toConsumableArray(props.materialNameSuffixOptions));
            var name = formValue.name + (formValue.nameSuffix ? "_" + formValue.nameSuffix : "");
            all.forEach(function(item) {
                name = name.replaceAll("{".concat(item.label, "}"), "{".concat(item.code, "}"));
            });
            emit("input", name);
        };
        var formRef = ref();
        var formValue = reactive({
            name: "",
            nameSuffix: ""
        });
        // 前缀（默认全选）
        watch(function() {
            return props.materialNameOptions;
        }, function(v) {
            formValue.name = v.filter(function(item) {
                return item.code !== PushNameCode.CreativeVersion;
            }).map(function(item) {
                return props.batch ? "{".concat(item.label, "}") : item.name;
            }).join("_");
            updateName();
        }, {
            immediate: true
        });
        // 后缀（默认全选）
        watch(function() {
            return props.materialNameSuffixOptions;
        }, function(v) {
            formValue.nameSuffix = v.map(function(item) {
                return "{".concat(item.label, "}");
            }).join("_");
            updateName();
        }, {
            immediate: true
        });
        watch(function() {
            return formValue.name;
        }, function(val) {
            updateName();
        });
        return {
            formValue: formValue,
            formRef: formRef,
            copyName: copyName,
            // method
            validateName: validateName
        };
    }
});
